import { useFonts } from 'expo-font';

export type UseLoadAssetsReturnValue = {
    isAssetLoadComplete: boolean;
};

export type FontWeight = 'light' | 'regular' | 'bold' | 'extrabold' | 'medium' | 'semi-bold';
export type FontFamilyNames =
    | 'OverpassRegular'
    | 'OverpassMedium'
    | 'OverpassBold'
    | 'OverpassSemibold'
    | 'OverpassLight'
    | 'OverpassExtraBold'
    | 'SuisseWorksBold';
export type FontFamily = 'Overpass' | 'SuisseWorks';

/*
    Overpass does not center font vertically correctly on some browsers (such as Chrome on Windows).  If the font needs to be changed for
    whatever reason, download the font, upload the files to https://transfonter.org/, and run a conversion.  When converting toggle "Fix vertical metrics" to "On".
    This corrects the vertical alignment issue.
*/
export const fontWeightToFontFamilyName: Record<FontFamily, Record<FontWeight, FontFamilyNames>> = {
    Overpass: {
        light: 'OverpassLight',
        regular: 'OverpassRegular',
        medium: 'OverpassMedium',
        'semi-bold': 'OverpassSemibold',
        bold: 'OverpassBold',
        extrabold: 'OverpassExtraBold',
    },
    SuisseWorks: {
        // For now, we only need bold, but make TS happy
        bold: 'SuisseWorksBold',
        light: 'SuisseWorksBold',
        regular: 'SuisseWorksBold',
        medium: 'SuisseWorksBold',
        'semi-bold': 'SuisseWorksBold',
        extrabold: 'SuisseWorksBold',
    },
};
export default function useLoadAssets(): UseLoadAssetsReturnValue {
    const [fontsLoaded] = useFonts({
        // OverpassLight: require('../assets/fonts/overpass-light.otf'),
        OverpassRegular: require('../assets/fonts/Overpass-Regular.ttf'),
        OverpassMedium: require('../assets/fonts/Overpass-Medium.ttf'),
        OverpassBold: require('../assets/fonts/Overpass-Bold.ttf'),
        OverpassSemibold: require('../assets/fonts/Overpass-SemiBold.ttf'),
        OverpassExtraBold: require('../assets/fonts/Overpass-ExtraBold.ttf'),
        SuisseWorksBold: require('../assets/fonts/suisseworks-bold.otf'),
        NeometricAltExtraBold: require('../assets/fonts/NeometricAltExtraBold.otf'),
    });

    return {
        isAssetLoadComplete: fontsLoaded,
    };
}
